import { TypeOfferForm } from "@types"

export const DDA_STATUS = {
    ACTIVE: "Active",
    OBSOLETE: "Obsolète",
    A_VALIDER: "A valider",
    REFUSED: "Refusée",
    ERROR: "Erreur",
    REVOKED: "Révoquée",
    RECHECK: "A revérifier",
    // cas interne quand il n'y a pas de DDA pour un PCE
    EMPTY: "Empty",
}

export const SOURCES_TYPES = {
    PDL: "pdl",
    PCE: "pce",
    GAZ_SNC: "snc-pce",
    GAZ_BOUTEILLE: "snc-gazbouteille",
    GAZ_CUVE: "snc-gazcuve",
    FIOUL: "snc-fioul",
    BOIS_GRANULE: "snc-boisgranule",
    BOIS_STERE: "snc-boisstere",
    BOIS_AUTO: "snc-boisauto",
    BOIS_COMPRESS: "snc-boiscompress",
    BOIS_PLAQUETTE: "snc-boisplaquette",
    CPCU: "cpcu",
    DALKIA: "dalkia",
    SIGDU: "sigdu",
    ELECSAVOIE: "elecsavoie",
    ELECSTRASBOURG: "elecstrasbourg",
    REGAZ: "regaz",
    // Sous-compteurs de l'Université de Bordeaux (DEV-2100) : un même idtype
    // porte élec, eau ou chaleur, lu dans `informations.ubordeaux.compteur.fluide`.
    UBORDEAUX: "ubordeaux",
    METEOFRANCE: "idmeteofrance",
    OPENMETEO: "idopenmeteo",
    METEO: "meteo",
    RTE: "rte",
    DEVEUI: "deveui",
    OBJENIOUS: "objenious",
    IDSIGFOX: "idsigfox",
    IDTECHEM: "idtechem",
    POINT_ID_CONTROLLER_ID_PROPERTY_ID: "point_id|controller_id|property_id",
}

export const METER_TYPES_LIST = [
    SOURCES_TYPES.PDL,
    SOURCES_TYPES.PCE,
    SOURCES_TYPES.CPCU,
    SOURCES_TYPES.DALKIA,
    SOURCES_TYPES.REGAZ,
    SOURCES_TYPES.ELECSAVOIE,
    SOURCES_TYPES.ELECSTRASBOURG,
    SOURCES_TYPES.SIGDU,
    SOURCES_TYPES.UBORDEAUX,
]

export const WEATHER_STATION_TYPES_LIST = [
    SOURCES_TYPES.METEOFRANCE,
    SOURCES_TYPES.OPENMETEO,
    SOURCES_TYPES.METEO,
]

export const IOT_TYPES_LIST = [
    SOURCES_TYPES.DEVEUI,
    SOURCES_TYPES.OBJENIOUS,
    SOURCES_TYPES.IDSIGFOX,
    SOURCES_TYPES.IDTECHEM,
    SOURCES_TYPES.POINT_ID_CONTROLLER_ID_PROPERTY_ID,
]

export const SOURCE_WITHOUT_RAW_FREQ = [
    SOURCES_TYPES.CPCU,
    SOURCES_TYPES.REGAZ,
    SOURCES_TYPES.DALKIA,
    SOURCES_TYPES.SIGDU,
    // dapi ne sert que `daily` et `hourly` (DEV-2100)
    SOURCES_TYPES.UBORDEAUX,
]
export const SOURCE_WITHOUT_HOURLY_FREQ = [
    SOURCES_TYPES.CPCU,
    SOURCES_TYPES.DALKIA,
    SOURCES_TYPES.REGAZ,
    SOURCES_TYPES.SIGDU,
]

export const OFFER_NAMES = {
    BASE: "Base",
    HPHC: "Heures Pleines/Creuses",
    TEMPO: "6 cadrans",
}

export const CONSENT_REQUEST_STATUS = {
    ACCEPTED: "ACCEPTED",
    WAITING_GRDF: "WAITING_GRDF",
    CREATED: "CREATED",
    REFUSED: "REFUSED",
    REMOVED: "REMOVED",
    EXPIRED: "EXPIRED",
    TERMINATED: "TERMINATED",
}

/** États de la demande de consentement multi (aligné api-metier) */
export const CONSENT_REQUEST_MULTI_STATE = {
    CREATED: "CREATED",
    ACCEPTED: "ACCEPTED",
    REFUSED: "REFUSED",
    REMOVED: "REMOVED",
    TERMINATED: "TERMINATED",
}

export const CONSENT_REQUEST_TYPE = {
    SHARE: "SHARE",
    SIGN: "SIGN",
    EXTEND: "EXTEND",
    CHANGE_OWNER: "CHANGE_OWNER",
}

export const CONSENT_STATUS = {
    ACTIVE: "active",
    REVOKED: "revoked",
    EXPIRED: "expired",
    NO_SIGN: "no-sign",
}

export const GRID_OFFER_CODES = {
    BASE: "Base",
    HPHC: "HPHC",
    TEMPO: "Tempo",
    OTHER: "Autre",
} as Record<"BASE" | "HPHC" | "TEMPO" | "OTHER", TypeOfferForm>

export const USAGE_TYPES_KEY = {
    CHAUFFAGE: "Chauffage",
    CLIMATISATION: "Climatisation",
    CUISINE: "Cuisson",
    EQUIPEMENTS_METIERS: "Équipements métiers",
    LAVE_VAISSELLE: "Lave-vaisselle",
    MACHINE_A_LAVER: "Machine à laver",
    MACHINES_INDUSTRIELLES: "Machines industrielles",
    PARTIES_COMMUNES: "Parties communes",
    VEHICULE_ELEC: "Véhicule électrique",
    ECS: "Eau chaude sanitaire",
    PISCINE: "Piscine",
    ELECTROMENAGER: "Autres électroménagers",
}
export const USAGE_TYPES = [
    USAGE_TYPES_KEY.CHAUFFAGE,
    USAGE_TYPES_KEY.CUISINE,
    USAGE_TYPES_KEY.CLIMATISATION,
    USAGE_TYPES_KEY.ELECTROMENAGER,
    USAGE_TYPES_KEY.VEHICULE_ELEC,
    USAGE_TYPES_KEY.ECS,
    USAGE_TYPES_KEY.PISCINE,
    USAGE_TYPES_KEY.EQUIPEMENTS_METIERS,
    USAGE_TYPES_KEY.LAVE_VAISSELLE,
    USAGE_TYPES_KEY.MACHINE_A_LAVER,
    USAGE_TYPES_KEY.MACHINES_INDUSTRIELLES,
    USAGE_TYPES_KEY.PARTIES_COMMUNES,
    USAGE_TYPES_KEY.VEHICULE_ELEC,
]

export const USAGES_RULES = {
    [SOURCES_TYPES.PCE]: [
        USAGE_TYPES_KEY.CHAUFFAGE,
        USAGE_TYPES_KEY.CUISINE,
        USAGE_TYPES_KEY.ECS,
        USAGE_TYPES_KEY.PISCINE,
        USAGE_TYPES_KEY.EQUIPEMENTS_METIERS,
        USAGE_TYPES_KEY.PARTIES_COMMUNES,
        USAGE_TYPES_KEY.MACHINES_INDUSTRIELLES,
    ],
    [SOURCES_TYPES.PDL]: [
        USAGE_TYPES_KEY.CHAUFFAGE,
        USAGE_TYPES_KEY.CLIMATISATION,
        USAGE_TYPES_KEY.CUISINE,
        USAGE_TYPES_KEY.ECS,
        USAGE_TYPES_KEY.EQUIPEMENTS_METIERS,
        USAGE_TYPES_KEY.LAVE_VAISSELLE,
        USAGE_TYPES_KEY.MACHINE_A_LAVER,
        USAGE_TYPES_KEY.MACHINES_INDUSTRIELLES,
        USAGE_TYPES_KEY.PARTIES_COMMUNES,
        USAGE_TYPES_KEY.PISCINE,
        USAGE_TYPES_KEY.VEHICULE_ELEC,
        USAGE_TYPES_KEY.ELECTROMENAGER,
    ],
    [SOURCES_TYPES.CPCU]: [
        USAGE_TYPES_KEY.CHAUFFAGE,
        USAGE_TYPES_KEY.EQUIPEMENTS_METIERS,
        USAGE_TYPES_KEY.PARTIES_COMMUNES,
        USAGE_TYPES_KEY.MACHINES_INDUSTRIELLES,
    ],
    [SOURCES_TYPES.DALKIA]: [
        USAGE_TYPES_KEY.CHAUFFAGE,
        USAGE_TYPES_KEY.EQUIPEMENTS_METIERS,
        USAGE_TYPES_KEY.PARTIES_COMMUNES,
        USAGE_TYPES_KEY.MACHINES_INDUSTRIELLES,
    ],
    [SOURCES_TYPES.SIGDU]: [
        USAGE_TYPES_KEY.CHAUFFAGE,
        USAGE_TYPES_KEY.EQUIPEMENTS_METIERS,
        USAGE_TYPES_KEY.PARTIES_COMMUNES,
        USAGE_TYPES_KEY.MACHINES_INDUSTRIELLES,
    ],
}

// Les messages d'erreurs en fonction du statut de la DDA
export const MESSAGES_DDA = {
    REFUSED: {
        // le Titulaire n'a pas reçu le Mail de Validation suite à la demande d'accès formulée par le Tiers. La demande d'accès est donc passée à Refusée.
        CASE_1: "Le titulaire n’a pas reçu le courriel de demande de validation du droit d’accès",
        // la demande d'accès a directement été Refusée par le Titulaire depuis le Mail de Validation.
        CASE_2: "Demande d’accès refusée",
        // la demande d'accès formulée par le Tiers n'a pas été validée ou refusée dans le délai de 3 Jours calendaires accordé. La demande d'accès est donc passée à Refusée.
        CASE_3: "La durée de validité de la demande d'accréditation est dépassée.",
        // le PCE du Titulaire a connu une Mise Hors Service (déménagement…), ce dernier n'est donc plus le Titulaire officiel du PCE (Rôle Autorisé).
        CASE_4: "Le client n'est plus titulaire de ce PCE",
    },
    OBSOLETE: {
        // la date de fin d'autorisation du droit d'accès est dépassée celui-ci est donc passé à Obsolète.
        CASE_1: "La date de fin d'autorisation de l'accréditation est dépassée.",
        // la date de fin d'autorisation du droit d'accès est dépassée celui-ci est donc passé à Obsolète. (ancienne version de l'API GRDF)
        CASE_2: "La date de fin d'accès est dépassée.",
        // le droit d'accès a été passé à Obsolète directement par GRDF (outils internes)
        CASE_3: "IHM Consultation accréditations",
        // le PCE du Titulaire a connu une Mise Hors Service (déménagement…), ce dernier n'est donc plus le Titulaire officiel du PCE (Rôle Autorisé)
        CASE_4: "Le client n'est plus titulaire de ce PCE.",
        // suite au renouvellement du droit d'accès ce dernier est passé à Obsolète car l'adresse email du titulaire n'est plus valide, ce dernier n'a donc pas recu le Mail d'information.
        CASE_5: "Le courriel du titulaire n’est plus valide",
    },
    REVOKED: {
        // le droit d'accès (anciennement actif) a été Révoqué par le Titulaire depuis le site Mon Espace GRDF
        CASE_1: "eConso",
        // le droit d'accès (anciennement actif) a été Révoqué par le Titulaire depuis le Mail de Validation.
        CASE_2: "Demande d'accès révoquée",
        // le droit d'accès a été Révoqué directement par GRDF (outils internes).
        CASE_3: "GRDF a passé le droit d'accès à l'état Révoqué",
        // le droit d'accès a été Révoqué directement par GRDF (outils internes).
        CASE_4: "DIGITAL CORNER",
        // le droit d'accès (anciennement actif) a été Révoqué par le Titulaire depuis le site Mon Espace GRDF
        CASE_5: "Accès révoqué par le tiers autorisé",
    },
    ERROR: {
        // Date de début du périmètre conso obligatoire / format YYYY-MM-DD (runerrors: declarer-droit-acces-1000000041)
        CASE_1: "declarer-droit-acces-1000000041",
        // Le numéro de PCE est inconnu.
        CASE_2: "declarer-droit-acces-1000000006-404",
        // Code postal non renseigné (runerrors: 1000000027)
        CASE_3: "declarer-droit-acces-1000000027",
        // Format du code postal incorrect (runerrors: 1000000036)
        CASE_4: "declarer-droit-acces-1000000036",
        // Code postal ne correspond pas à l'adresse du PCE (runerrors: 1000000005)
        CASE_5: "declarer-droit-acces-1000000005",
        // Le contrat de fourniture de gaz est échu.
        CASE_6: "declarer-droit-acces-1000000004",
        // Date début périmètre conso doit être ≤ date du jour (runerrors: 1000000019)
        CASE_7: "declarer-droit-acces-1000000019",
        // cas où le nom du titulaire est vide
        CASE_8: "declarer-droit-acces-1000000026",
    },
}

export const PCE_DDA_STATUS = {
    ACTIVE: "Active",
    OBSOLETE: "Obsolète",
    A_VALIDER: "A valider",
    REFUSED: "Refusée",
    ERROR: "Erreur",
    REVOKED: "Révoquée",
    RECHECK: "A revérifier",
    // cas interne quand il n'y a pas de DDA pour un PCE
    EMPTY: "Empty",
}

/**
 * Catégories de types de sources pour les filtres de consentements
 */
export const SOURCE_TYPE_CATEGORIES = {
    ELEC: {
        label: "Électricité",
        types: [
            SOURCES_TYPES.PDL,
            SOURCES_TYPES.ELECSAVOIE,
            SOURCES_TYPES.ELECSTRASBOURG,
        ],
    },
    GAZ: {
        label: "Gaz",
        types: [SOURCES_TYPES.PCE, SOURCES_TYPES.REGAZ],
    },
    RCU: {
        label: "RCU",
        types: [SOURCES_TYPES.CPCU, SOURCES_TYPES.DALKIA],
    },
    EAU: {
        label: "Eau",
        types: [SOURCES_TYPES.SIGDU],
    },
} as const
